var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PrimaryLayout',[_c('div',{staticClass:"section w-container flex flex-row"},[_vm._v(" Gallery ! ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }